import type { IconName } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

import Icon from '@components/Icon/Icon';

import { IconWrapper, LineItem } from './RecordTimelineCategory.style';

const RecordTimelineCategory: React.FC<{
  /**
   * Name of the icon to show on the component
   */
  iconName?: IconName | null;

  iconColor?: string;
  /**
   * Text to show next to the image
   */
  text?: string | null;
}> = ({ iconName, iconColor, text = '' }) => {
  return (
    <LineItem>
      <IconWrapper>
        {iconName ? <Icon clickable color={iconColor} name={iconName} /> : null}
      </IconWrapper>
      {text}
    </LineItem>
  );
};

export default RecordTimelineCategory;
